'use strict';

/**
 * Controler definition for share
 *
 * @category   Controller
 * @module     share
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Controller = require('base/Colido.Controller');
var ShareLayout = require('./views/layout/share');
var EmptyShareView = require('./views/layout/empty-share');
var ParameterizedCollection = require('base/Colido.ParameterizedCollection');
var SettingsObjectListModel = require('./models/settings-object-list');
var CatalogsCollection = require('modules/collection/collections/catalogs');
var ObjectsCollection = require('modules/collection/collections/objects');
var ShareModel = require('./models/share');

var messages = require('messages/messages');

var ShareModuleController = Controller.extend({
    routes: {
        'close-window': 'actionCloseWindow',
        ':token(/show/:item)': 'actionIndex',
    },

    params: null,

    shareModel: null,

    initialize: function (options) {
        this.app = options.app;
    },

    actionIndex: function(token, activeObject) {
        if (App.rootView.contentRegion.currentView instanceof ShareLayout
            && this.shareModel
            && _.contains(['set', 'location', 'object'], this.shareModel.get('type'))
        ) {
            this.activateNewItem(activeObject);

            return;
        }

        $.ajaxSetup({
            headers: {'colido-sharetoken': token},
        });

        var catalogs = new CatalogsCollection();
        App.loadData(catalogs);

        this.onDataReady(catalogs, function() {
            var catalog = catalogs.at(0);

            App.requireData([
                catalog.objects,
            ], {
                success: function() {
                    this.shareModel = new ShareModel({
                        token: token,
                        catalog: catalog,
                    });

                    this.shareModel.fetch({
                        success: function(model) {
                            if (_.contains(['set', 'location', 'object'], model.get('type'))) {
                                this.showSharedObjects(this.shareModel, activeObject);
                            } else {
                                this.showEmptyView();
                            }
                        }.bind(this),
                        error: function() {
                            this.showEmptyView();
                        }.bind(this),
                    });
                }.bind(this),

                loading: function(){
                    //noop. default behavior requires different dom and breaks
                },
            });
        }.bind(this),
        function(notReady){
            //noop. default behavior requires different dom and breaks
        });
    },

    actionCloseWindow: function () {
        window.close();
    },

    showEmptyView: function() {
        var contentRegion = App.rootView.contentRegion;
        contentRegion.show(new EmptyShareView());
    },

    /**
     * Activates a new item in the showroom
     * @param {number}|{null} activeObject ID of the item to show
     */
    activateNewItem: function(activeObject) {
        var objectsRegionView = App.rootView.contentRegion.currentView.objectsRegion.currentView;
        objectsRegionView.triggerMethod('showroom:detail:select:id', activeObject);
    },

    /**
     * Shows and builds the showroom view
     * @param {ShareModel} shareModel   The share model
     * @param {number}     activeObject Item to activate
     */
    showSharedObjects: function(shareModel, activeObject) {
        var contentRegion = App.rootView.contentRegion;

        var params = new SettingsObjectListModel({
            catalog: shareModel.get('catalog'),
        });

        params.set('shareModel', shareModel);

        var paramCollection = new ParameterizedCollection(undefined, {
            params: params,
            collection: shareModel.get('catalog').objects,
        });

        var viewOptions = {
            model: params,
            collection: paramCollection,
            baseCollection: shareModel.get('catalog').objects,
            shareModel: shareModel,
            activeObject: activeObject,
        };

        var shareLayoutView = new ShareLayout(viewOptions);

        // Listen for attach, to remove loading spinner
        this.listenTo(shareLayoutView, 'attach', function() {
            contentRegion.$el.removeClass('loading');
        });

        contentRegion.show(shareLayoutView);
    },
});

module.exports = ShareModuleController;